import { useEffect, useState } from "react";
import { deleteTalle, getTallesPanel } from "../../services/TallesServices";
import { TallesContext } from "./TallesContext"

export const TallesState = ({ children }) => {

    const getTallesPanelData = async (search,numpag,filas) => {
        let res = await getTallesPanel(search,numpag,filas)
        return res;
    }

    const deleteTalleData = async (body,search,numpag,filas) => {
        const res = await deleteTalle(body)
        if (res) getTallesPanelData(search,numpag,filas)
        return res
    }

    return <TallesContext.Provider value={{
        deleteTalleData,
        getTallesPanelData,
    }} >
        {children}
    </TallesContext.Provider>
}